import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
import { OrgChart } from 'd3-org-chart';
import styles from "../styles/CompanyTree.module.css";
import * as d3 from "d3"
import { MinusCircleOutlined, MinusCircleTwoTone, PlusCircleOutlined, PlusCircleTwoTone, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';

const CompanyTree = ({ data = [], lang = "", graphRef = null }) => {
  const { t } = useTranslation();
  const positionList = data
  const svgRef = useRef();
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);

  console.log("transformData", transformData(positionList));


  function transformData(data, lang) {
    // console.log("companyInformation", companyInformation);

    const result = [];

    function traverse(node, parentId = null) {
      console.log("node", node);

      const transformedNode = {
        id: node.positionId || node.id,
        parentId: parentId || null,
        name: node?.['positionName' + (lang == 'en' ? "En" : "")] || node.name,
        position: node.level || 'Unknown Position',
        image: node.image || '',
        email: node.email || '',
        phone_number: node.phone_number || '',
        hire_date: node.hire_date || '',
        preventExpand: true
      };

      result.push(transformedNode);

      if (node.children && node.children.length > 0) {
        node.children.forEach(child => traverse(child, transformedNode.id));
      }
    }
    data.map(o => traverse(o))
    return result;
  }

  useEffect(() => {
    // Log root data for debugging

    // Check if the root data is valid
    const chartContainer = chartRef.current;

    // Ensure chart container is available
    if (!chartContainer) {
      console.error("Chart container is not available.");
      return;
    }
    // Initialize OrgChart only after container is available
    const orgChart = new OrgChart()
      .nodeHeight((d) => 50 + 25)
      .nodeWidth((d) => 300 + 2)
      .childrenMargin((d) => 150)
      .compactMarginBetween((d) => 200)
      .compactMarginPair((d) => 200)
      .neighbourMargin((a, b) => 200)

      // .scaleExtent([1, 1])
      // .scaleExtent([0.3, 1])
      // .connectionsUpdate(() => {
      //   d3.select(this)
      //     .attr("stroke", "red") // Set your desired link color
      //     .attr("stroke-width", "2")
      //     .attr("stroke-linecap", "round")
      //     .attr('pointer-events', 'none')
      //     .attr("marker-start", (d) => `url(#${d.from + "_" + d.to})`)
      //     .attr("marker-end", (d) => `url(#arrow-${d.from + "_" + d.to})`);
      // })
      .buttonContent(() => { })
      .onNodeClick((d) => console.log(d))
      .nodeContent(function (d) {
        const color = '#FFFFFF';
        const imageDiffVert = 25 + 2;
        return `
            <div id='node-na' style="width:${d.width}px;height:${d.height}px;padding-left:1px;padding-right:1px;">
              <div style="background-color:${color};margin-left:-1px;width:${d.width - 2}px;border-radius:100px;border: 1px solid black ;padding-left :20px;padding-right :20px;">
                <div style="min-height:${d.height}px;align-content:center;font-size:1.3vw;color:#08011E;text-align:center ;white-space: normal; word-wrap: break-word; overflow: hidden; text-overflow: ellipsis;">${d.data?.name}</div>
              </div>
            </div>`;
      })
      .container(chartContainer)
      .data(transformData(positionList, lang))
      .render();
    // Set chart to state for future manipulation (optional)

    // Styling the connections with custom arrowheads
    const svg = d3.select(chartContainer).select("svg");

    if (svg) {
      svg.selectAll(".node")
        .style("cursor", "default");
    }
    orgChart?.expandAll()
    orgChart?.compact?.(false).render();
    // Disable the expand/collapse button specifically
    orgChart?.nodeButtonWidth((node) => node.data?.preventExpand ? 0 : 20)
      .nodeButtonHeight((node) => node.data?.preventExpand ? 0 : 20);
    const rootNodeId = positionList[0]?.positionId; // Assuming the first item is the root
    if (rootNodeId) {
      orgChart.setCentered(rootNodeId);
    }

    const adjustChartSize = () => {
      orgChart.fit();
    };
    setChart(orgChart);
    // Cleanup on component unmount
    return () => {
      if (chart) {
        chart?.destroy?.();
      }
    };
  }, [positionList, lang]);

  useEffect(() => {

    graphRef.current = chart
  }, [chart])

  return (
    <div>
      <div className={styles.stylesNode}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', gap: "12px" }}>
          {/* <Button onClick={() => chart.exportImg({ full: true })} style={{ marginRight: 10 }}>
            Download
          </Button> */}
          <Button onClick={() => {
            chart.nodeHeight(() => 125 + 25);
            chart.layout('left').render().fit()
          }}>
            {t("og_chart.left")}
          </Button>
          <Button onClick={() => {
            chart.nodeHeight(() => 50 + 25);
            chart.layout('top').render().fit()
          }}>
            {t("og_chart.top")}
          </Button>
        </div>
        <div id="chart" style={{ width: "100%" }} ref={chartRef} className="chart-container"></div>
      </div>
    </div>
  );

  //   return data.map((node) => (
  //     <div id="chart">
  //       <Tree
  //         nodePadding="24px"
  //         lineHeight="19px"
  //         label={
  //           <div className={styles.stylesNode}>
  //             {lang == "en" ? node?.positionNameEn : node?.positionName}
  //           </div>
  //         }
  //       >
  //         {node?.children?.length > 0 ? renderTreeNodes(node?.children, lang) : null}
  //       </Tree>
  //     </div>
  //   ));
};

// const renderTreeNodes = (nodes, lang) => {
//   return nodes.map((node) => (
//     <TreeNode
//       key={node.positionId}
//       label={
//         <div className={styles.stylesNode}>
//           {lang == "en" ? node.positionNameEn : node.positionName}
//         </div>
//       }
//     >
//       {node.children.length > 0 ? renderTreeNodes(node.children, lang) : null}
//     </TreeNode>
//   ));
// };

export default CompanyTree;
